export default __webpack_public_path__ + "static/media/ic-timer-delay.20dc980f.svg";